import React from 'react';
import PropTypes from 'prop-types';
import { ModalHeader as ReactModalHeader } from 'reactstrap';
import { Divider, Icon, Typography } from "../../index";
import './modal.scss';

export const ModalHeader = ({
    alignText,
    children,
    icon,
    onCloseClick,
    branded
}) => {

    const closeBtn = <button className="modal-close-btn" onClick={() => onCloseClick()} aria-label="close" type="button">
        <div className="modal-close-label">
            <Typography type="body-02">Close</Typography>
            <Icon name="x" size="medium" color="$color-primary-a3" />
        </div>
    </button>;

    const showBorder = (branded || (!branded && children && !icon)) ? true : false;
    const showIcon = (!branded && icon) ? true : false;

    const modalHeaderClasses = [
        `bsw-modal-header`,
        `${onCloseClick ? 'bsw-modal-header-with-close' : ''}`,
        `${showIcon ? 'bsw-modal-header-with-icon' : ''}`
    ].join(' ');

    return (<>
        <ReactModalHeader
            className={modalHeaderClasses}
            close={onCloseClick ? closeBtn : null}
        >
            {branded && <img className="bswh-symbol" src="https://bswcdndesign-prod.bswhealth.com/content/logo/bswh-symbol.svg" />}
            {showIcon && <div className="bsw-modal-icon" style={{ textAlign: `${alignText}` }}><Icon name={icon} set="brand" size="large" /></div>}
            {children &&
                <Typography
                    color={"$color-primary-a2"}
                    type={branded ? "body-03" : "heading-04"}
                    tag="div"
                    textAlign={branded ? "left" : alignText}
                    responsive
                >
                    {children}
                </Typography>
            }
        </ReactModalHeader>
        {showBorder && <Divider mLeft="none" mRight="none" mTop="none" mBottom="none" />}
    </>
    );
}
